import React from "react";

export default function Resource() {
    return(
        <section className="inter">
            <h2 className="inter-title">课外资料推荐</h2>
            <ul className="inter-con">
                 <li className="resource1">
                    <a href="#">
                        <div className="inter-box">
                            <h3 className="inter-title"></h3>
                            <p className="inter-info"></p>
                        </div>
                    </a>
                </li>

            </ul>
        </section>
    )

}
